import { toast } from "react-toastify";
import { ERROR_STATUS, SUCCESS_STATUS } from "../../status/status";

const SERVER_URL = process.env.REACT_APP_API
  ? process.env.REACT_APP_API
  : "/api";

//cookie functions
export const setCookie = (key, value) => {
  localStorage.setItem(key, value);
};

const convertToInt = async (formData) => {
  return Object.fromEntries(
    Object.entries(Object.fromEntries(formData)).map(([key, value]) => [
      key,
      value === undefined || value === null || value === "" || value === "NaN"
        ? null
        : isNaN(value)
        ? value.startsWith("[")
          ? JSON.parse(value)
          : value
        : Number(value),
    ])
  );
};

export const getCookie = (key) => {
  const data = localStorage.getItem(key);
  return data;
};

export const delCookie = (key) => {
  localStorage.removeItem(key);
};

const authToken = getCookie("authToken");

//login
export const authentication = async ({ request }) => {
  const formData = await request.formData();

  const body = {
    username: formData.get("username"),
    password: formData.get("password"),
  };

  try {
    const res = await fetch(`${SERVER_URL}/account/sign-in`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (res.ok) {
      const data = await res.json();
      setCookie("authToken", data.token);
      setCookie("username", data.full_name);
      window.location.href = "/dashboard";
      return toast.success(SUCCESS_STATUS.LOGIN);
    } else if (res.status === 400) {
      return toast.error(ERROR_STATUS.INCOMPLETE);
    } else if (res.status === 402) {
      return toast.error(ERROR_STATUS.FORBIDDEN);
    } else if (res.status === 403) {
      return toast.error(ERROR_STATUS.SUBSCRIPTION);
    } else if (res.status === 406) {
      return toast.error(ERROR_STATUS.INCOMPLETE);
    }
  } catch (err) {
    console.log(err);
    return toast.error(ERROR_STATUS.SERVER);
  }
};

export const registerUserNumber = async (formData, url) => {
  try {
    const res = await fetch(`${SERVER_URL}${url}`, {
      method: "POST",
      body: formData,
    });

    const data = await res.json();
    if (res.ok) {
      return { data, msg: "ok" };
    } else {
      return { data, msg: "error" };
    }
  } catch (err) {
    console.log(err);
    toast.error(ERROR_STATUS.SERVER);
  }
};

export const registerUserCode = async (formData, url) => {
  try {
    const res = await fetch(`${SERVER_URL}${url}`, {
      method: "PUT",
      body: formData,
    });

    const data = await res.json();
    if (res.ok) {
      return { data, msg: "ok" };
    } else {
      return { data, msg: "error" };
    }
  } catch (err) {
    console.log(err);
    toast.error(ERROR_STATUS.SERVER);
  }
};

//logout
export const logout = async () => {
  delCookie("authToken");
  window.location.href = "/login";
};

//add to favorite
export const addToFavorit = async (formData, url) => {
  // convert to int
  const body = await convertToInt(formData);

  try {
    const res = await fetch(`${SERVER_URL}${url}`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: `token ${authToken}`,
      },
      body: JSON.stringify(body),
    });

    if (res.ok) toast.success(SUCCESS_STATUS.ADD_TO_FAVORITES);
    else if (res.status === 400) toast.warning(ERROR_STATUS.REPEAT);
    else toast.error(ERROR_STATUS.SERVER);
  } catch (err) {
    console.log(err);
    toast.error(ERROR_STATUS.SERVER);
  }
};

// delete
export const deleteFromFavorit = async (url) => {
  try {
    const res = await fetch(`${SERVER_URL}${url}`, {
      method: "DELETE",
      headers: {
        "content-type": "application/json",
        Authorization: `token ${authToken}`,
      },
    });
    if (res.ok) {
      toast.success(SUCCESS_STATUS.REMOVE_FROM_FAVORITES);
      return { msg: "successfuly" };
    }
    return { msg: "failed" };
  } catch (err) {
    console.log(err);
    toast.error(ERROR_STATUS.SERVER);
    return { msg: "failed" };
  }
};

//show chart
export const showChart = async (formData, url) => {
  const body = await convertToInt(formData);

  try {
    const res = await fetch(`${SERVER_URL}${url}`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: `token ${authToken}`,
      },
      body: JSON.stringify(body),
    });

    if (res.ok) {
      const data = await res.json();
      return data;
    }
  } catch (err) {
    console.log(err);
    toast.error(ERROR_STATUS.SERVER);
  }
};

export const addTicket = async (formData, url) => {
  try {
    const res = await fetch(`${SERVER_URL}${url}`, {
      method: "POST",
      headers: {
        Authorization: `token ${authToken}`,
      },
      body: formData,
    });

    if (res.ok) {
      const data = await res.json();
      toast.success(SUCCESS_STATUS.SEND_TICKET);
      return { data, status: res.status };
    }
  } catch (err) {
    console.log(err);
    toast.error(ERROR_STATUS.SERVER);
  }
};

//PUT,PATCH METHOD
export const updateData = async (formData, url, method) => {
  try {
    const res = await fetch(`${SERVER_URL}${url}`, {
      method: method === "PATCH" ? "PATCH" : "PUT",
      headers: {
        "content-type": "application/json",
        Authorization: `token ${authToken}`,
      },
      body: JSON.stringify(formData),
    });

    const data = await res.json();

    if (res.status === 401) {
      delCookie("authToken");
      window.location.href = "/login";
    }

    if (res.ok) {
      toast.success(SUCCESS_STATUS.UPDATE);
      return { data, msg: "ok" };
    } else {
      return { data, msg: "error" };
    }
  } catch (err) {
    console.log(err);
    toast.error(ERROR_STATUS.SERVER);
  }
};

//POST METHOD
export const sendData = async (formData, url, params) => {
  try {
    const formattedUrl = params ? `${url}?${params}` : url;

    const res = await fetch(`${SERVER_URL}${formattedUrl}`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: `token ${authToken}`,
      },
      body: JSON.stringify(formData),
    });

    const data = await res.json();

    if (res.status === 401) {
      delCookie("authToken");
      window.location.href = "/login";
    }

    if (res.ok) {
      toast.success(data.message && data.message);
      return { data, status: res.status };
    } else {
      toast.error(data.message && data.message);
      return { status: res.status };
    }
  } catch (err) {
    console.log(err);
    toast.error(ERROR_STATUS.SERVER);
  }
};

//DELETE METHOD
export const deleteData = async (url) => {
  try {
    const res = await fetch(`${SERVER_URL}${url}`, {
      method: "DELETE",
      headers: {
        "content-type": "application/json",
        Authorization: `token ${authToken}`,
      },
    });

    const data = await res.json();

    if (res.status === 401) {
      delCookie("authToken");
      window.location.href = "/login";
    }

    if (res.ok) {
      toast.success(data.message && data.message);
      return { data, status: res.status };
    } else {
      toast.error(data.message && data.message);
      return { status: res.status };
    }
  } catch (err) {
    console.log(err);
    toast.error(ERROR_STATUS.SERVER);
  }
};
